
import React, { useState } from 'react';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import { Badge, ButtonPrimary, Loader, ModalContent, ModalHeader } from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
import { ExtendedUser } from '../../../../store/users/types';
import style from './UserManagementResetPassword.module.scss';
import { useDispatch } from 'react-redux';
import { postResetPassword } from '../../../../store/users/actions';
import { useToast } from '../../../../hooks/useToast';

interface IUserManagementResetPasswordProps {
  user?: ExtendedUser;
  onClose: () => void;
}

export const UserManagementResetPassword: React.FunctionComponent<IUserManagementResetPasswordProps> = (
  {
    user,
    onClose
  }
) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { addToast } = useToast();

  const [isFetching, setFetching] = useState<boolean>(false);

  const onClickClose = () => !isFetching && onClose();
  

  const postCompleted = () => {
      setFetching(false);
      onClose();
      addToast({
          status: 'ok',
          message: user?.userName + t('User_password_reseted')
      })
  }

  const onClickSubmit = async () => {
    const failedReset = () => {
      setFetching(false);
      onClose();
      addToast({
        status: 'danger',
        message: t('resetUserPasswordFailed')
      })
    }
    dispatch(postResetPassword(user, postCompleted, failedReset));
    setFetching(true);
  };

  return (
    <FullscreenModal
      onClose={onClickClose}
      className={style.modal}
    >
      <ModalHeader
        onClose={onClickClose}
      >
        {t('Reset_User')}
      </ModalHeader>
      <ModalContent className={style.content}>
        <>
          <Loader
            center
            show={isFetching}
            className={style.loader}
          />
          <div className={isFetching ? style.blur : ''}>
            <div className={style.container}>
              {t('Reset_user_trying')}
              <Badge
                className={style.badge}
              >{user?.userName}</Badge>
              , {t('are_you_sure')}?
            </div>
            <div className={style.navigation}>
              <ButtonPrimary
                onClick={onClickClose}
                outline
              >
                {t('Cancel')}
              </ButtonPrimary>
              <ButtonPrimary
                onClick={onClickSubmit}
              >
                {t('Ok')}
              </ButtonPrimary>
            </div>
          </div>
        </>
      </ModalContent>
    </FullscreenModal>
  );
};